import {
  START_GET_SURGERY_LIST,
  SUCCESS_GET_SURGERY_LIST,
  ERROR_GET_SURGERY_LIST,
  START_CREATE_SURGERY,
  SUCCESS_CREATE_SURGERY,
  ERROR_CREATE_SURGERY,
  START_UPDATE_SURGERY,
  SUCCESS_UPDATE_SURGERY,
  ERROR_UPDATE_SURGERY,
  START_DELETE_SURGERY,
  SUCCESS_DELETE_SURGERY,
  ERROR_DELETE_SURGERY,
  RESET_SURGERY_STATE,
  START_GET_DRIVER_LIST,
  SUCCESS_GET_DRIVER_LIST,
  ERROR_GET_DRIVER_LIST,
  START_GET_SINGLE_SURGERY,
  SUCCESS_GET_SINGLE_SURGERY,
  ERROR_GET_SINGLE_SURGERY,
  START_WORKING_DAY_LIST,
  SUCCESS_WORKING_DAY_LIST,
  ERROR_WORKING_DAY_LIST,
  START_GET_SURGERY_NOTE_LIST,
  SUCCESS_GET_SURGERY_NOTE_LIST,
  ERROR_GET_SURGERY_NOTE_LIST,
  START_CREATE_SURGERY_NOTE,
  SUCCESS_CREATE_SURGERY_NOTE,
  ERROR_CREATE_SURGERY_NOTE,
  START_UPDATE_SURGERY_NOTE,
  SUCCESS_UPDATE_SURGERY_NOTE,
  ERROR_UPDATE_SURGERY_NOTE,
  START_GET_SINGLE_SURGERY_NOTE,
  SUCCESS_GET_SINGLE_SURGERY_NOTE,
  ERROR_GET_SINGLE_SURGERY_NOTE,
  START_DELETE_SURGERY_NOTE,
  SUCCESS_DELETE_SURGERY_NOTE,
  ERROR_DELETE_SURGERY_NOTE,
  START_GET_PRINT_SURGERY_LIST,
  SUCCESS_GET_PRINT_SURGERY_LIST,
  ERROR_GET_PRINT_SURGERY_LIST,
  START_UPDATE_FIELD_SURGERY,
  SUCCESS_UPDATE_FIELD_SURGERY,
  ERROR_UPDATE_FIELD_SURGERY,
  START_CREATE_SURGERY_MULTI,
  SUCCESS_CREATE_SURGERY_MULTI,
  ERROR_CREATE_SURGERY_MULTI,
} from "Actions/SurgeryAction";

const initialState = {
  surgeryList: {
    loading: false,
    data: {},
    error: {},
    success: false,
  },
  createSurgeryData: {
    loading: false,
    data: {},
    error: {},
  },
  updateSurgeryData: {
    loading: false,
    data: {},
    error: {},
  },
  deleteSurgeryData: {
    loading: false,
    data: {},
    error: {},
  },
  singleSurgery: {
    loading: false,
    data: {},
    error: {},
  },
  driverList: {
    loading: false,
    data: {},
    error: {},
  },
  workingDayList: {
    loading: false,
    data: {},
    error: {},
  },
  surgeryNoteList: {
    loading: false,
    data: {},
    error: {},
  },
  createSurgeryNoteData: {
    loading: false,
    data: {},
    error: {},
  },
  updateSurgeryNoteData: {
    loading: false,
    data: {},
    error: {},
  },
  singleSurgeryNote: {
    loading: false,
    data: {},
    error: {},
  },
  deleteSurgeryNoteData: {
    loading: false,
    data: {},
    error: {},
  },
  printSurgeryList: {
    loading: false,
    data: [],
  },
  createSurgeryMultiData: {
    loading: false,
    data: {},
    error: {},
  },
};

export const SurgeryReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESET_SURGERY_STATE: {
      return {
        ...state,
        [action.key]: action?.payload || initialState[action.key],
      };
    }
    case START_GET_SURGERY_LIST: {
      let oldList = state?.surgeryList?.data;
      return {
        ...state,
        surgeryList: {
          loading: action?.payload?.offset > 0 ? false : true,
          data: action?.payload?.offset > 0 ? oldList : {},
          error: {},
          success: false,
        },
      };
    }
    case SUCCESS_GET_SURGERY_LIST: {
      let oldList = state?.surgeryList?.data;
      if (oldList?.list?.length > 0) {
        oldList.list = [...oldList?.list, ...action?.payload?.data?.list];
      } else {
        oldList = action?.payload?.data;
      }
      return {
        ...state,
        surgeryList: {
          loading: false,
          data: oldList,
          error: {},
          success: true,
        },
      };
    }
    case ERROR_GET_SURGERY_LIST: {
      return {
        ...state,
        surgeryList: {
          loading: false,
          data: {},
          error: {},
          success: false,
        },
      };
    }
    case START_CREATE_SURGERY: {
      return {
        ...state,
        createSurgeryData: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_CREATE_SURGERY: {
      let oldList = state?.surgeryList?.data;
      oldList.list = [action?.payload?.data, ...oldList?.list];
      oldList.filterd_record = oldList?.filterd_record + 1;
      return {
        ...state,
        createSurgeryData: {
          loading: false,
          data: action.payload,
          error: {},
        },
      };
    }
    case ERROR_CREATE_SURGERY: {
      return {
        ...state,
        createSurgeryData: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_CREATE_SURGERY_MULTI: {
      return {
        ...state,
        createSurgeryMultiData: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_CREATE_SURGERY_MULTI: {
      let oldList = state?.surgeryList?.data;
      // oldList.list = [action?.payload?.data, ...oldList?.list];
      // oldList.filterd_record = oldList?.filterd_record + 1;
      return {
        ...state,
        createSurgeryMultiData: {
          loading: false,
          data: action.payload,
          error: {},
        },
      };
    }
    case ERROR_CREATE_SURGERY_MULTI: {
      return {
        ...state,
        createSurgeryMultiData: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_UPDATE_SURGERY: {
      return {
        ...state,
        updateSurgeryData: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }

    case SUCCESS_UPDATE_SURGERY: {
      let oldList = state?.surgeryList?.data;
      oldList.list = oldList?.list?.map((item) => {
        if (item?.id == action?.id) {
          return {
            ...item,
            ...action?.payload?.data,
          };
        } else {
          return item;
        }
      });
      return {
        ...state,
        updateSurgeryData: {
          loading: false,
          data: action.payload,
          error: {},
        },
      };
    }
    case ERROR_UPDATE_SURGERY: {
      return {
        ...state,
        updateSurgeryData: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_UPDATE_FIELD_SURGERY: {
      return {
        ...state,
        updateSurgeryData: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_UPDATE_FIELD_SURGERY: {
      let oldList = state?.surgeryList?.data;
      oldList.list = oldList?.list?.map((item) => {
        if (item?.id == action?.id) {
          return {
            ...item,
            ...action?.payload?.data,
          };
        } else {
          return item;
        }
      });
      return {
        ...state,
        updateSurgeryData: {
          loading: false,
          data: action.payload,
          error: {},
        },
      };
    }
    case ERROR_UPDATE_FIELD_SURGERY: {
      return {
        ...state,
        updateSurgeryData: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_DELETE_SURGERY: {
      return {
        ...state,
        deleteSurgeryData: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_DELETE_SURGERY: {
      let oldList = state?.surgeryList?.data;
      oldList.list = oldList?.list?.filter((item) => item?.id != action?.id);
      oldList.filterd_record = oldList?.filterd_record - 1;
      return {
        ...state,
        deleteSurgeryData: {
          loading: false,
          data: action.payload,
          error: {},
        },
      };
    }
    case ERROR_DELETE_SURGERY: {
      return {
        ...state,
        deleteSurgeryData: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_GET_SINGLE_SURGERY: {
      let oldList = state?.singleSurgery?.data;
      return {
        ...state,
        singleSurgery: {
          loading: true,
          data: action?.payload?.offset > 0 ? oldList : {},
          error: {},
        },
      };
    }
    case SUCCESS_GET_SINGLE_SURGERY: {
      let oldList = state?.singleSurgery?.data;
      if (oldList?.list?.length > 0) {
        oldList.list = [...oldList?.list, ...action?.payload?.data?.list];
      } else {
        oldList = action?.payload?.data;
      }
      return {
        ...state,
        singleSurgery: {
          loading: false,
          data: oldList,
          error: {},
        },
      };
    }
    case ERROR_GET_SINGLE_SURGERY: {
      return {
        ...state,
        singleSurgery: {
          loading: false,
          data: {},
          error: {},
        },
      };
    }
    case START_GET_DRIVER_LIST: {
      let oldList = state?.driverList?.data;
      return {
        ...state,
        driverList: {
          loading: action?.payload?.offset > 0 ? false : true,
          data: action?.payload?.offset > 0 ? oldList : {},
          error: {},
        },
      };
    }
    case SUCCESS_GET_DRIVER_LIST: {
      let oldList = state?.driverList?.data;
      if (oldList?.list?.length > 0) {
        oldList.list = [...oldList?.list, ...action?.payload?.data?.list];
      } else {
        oldList = action?.payload?.data;
      }
      return {
        ...state,
        driverList: {
          loading: false,
          data: oldList,
          error: {},
        },
      };
    }
    case ERROR_GET_DRIVER_LIST: {
      return {
        ...state,
        driverList: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_WORKING_DAY_LIST: {
      let oldList = state?.workingDayList?.data;
      return {
        ...state,
        workingDayList: {
          loading: action?.payload?.offset > 0 ? false : true,
          data: action?.payload?.offset > 0 ? oldList : {},
          error: {},
        },
      };
    }
    case SUCCESS_WORKING_DAY_LIST: {
      let oldList = state?.workingDayList?.data;
      if (oldList?.list?.length > 0) {
        oldList.list = [...oldList?.list, ...action?.payload?.data?.list];
      } else {
        oldList = action?.payload?.data;
      }
      return {
        ...state,
        workingDayList: {
          loading: false,
          data: oldList,
          error: {},
        },
      };
    }
    case ERROR_WORKING_DAY_LIST: {
      return {
        ...state,
        workingDayList: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_GET_SURGERY_NOTE_LIST: {
      let oldList = state?.surgeryNoteList?.data;
      return {
        ...state,
        surgeryNoteList: {
          loading: action?.payload?.offset > 0 ? false : true,
          data: action?.payload?.offset > 0 ? oldList : {},
          error: {},
        },
      };
    }
    case SUCCESS_GET_SURGERY_NOTE_LIST: {
      let oldList = state?.surgeryNoteList?.data;
      if (oldList?.list?.length > 0) {
        oldList.list = [...oldList?.list, ...action?.payload?.data?.list];
      } else {
        oldList = action?.payload?.data;
      }
      return {
        ...state,
        surgeryNoteList: {
          loading: false,
          data: oldList,
          error: {},
        },
      };
    }
    case ERROR_GET_SURGERY_NOTE_LIST: {
      return {
        ...state,
        surgeryNoteList: {
          loading: false,
          data: {},
          error: {},
        },
      };
    }
    case START_CREATE_SURGERY_NOTE: {
      return {
        ...state,
        createSurgeryNoteData: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_CREATE_SURGERY_NOTE: {
      let oldList = state?.surgeryNoteList?.data;
      oldList.list = [action?.payload?.data, ...oldList?.list];
      oldList.filterd_record = oldList?.filterd_record + 1;
      return {
        ...state,
        createSurgeryNoteData: {
          loading: false,
          data: action.payload,
          error: {},
        },
      };
    }
    case ERROR_CREATE_SURGERY_NOTE: {
      return {
        ...state,
        createSurgeryNoteData: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_UPDATE_SURGERY_NOTE: {
      return {
        ...state,
        updateSurgeryNoteData: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_UPDATE_SURGERY_NOTE: {
      let oldList = state?.surgeryNoteList?.data;
      oldList.list = oldList?.list?.map((item) => {
        if (item?.id == action?.id) {
          return {
            ...item,
            ...action?.payload?.data,
          };
        } else {
          return item;
        }
      });
      return {
        ...state,
        updateSurgeryNoteData: {
          loading: false,
          data: action.payload,
          error: {},
        },
      };
    }
    case ERROR_UPDATE_SURGERY_NOTE: {
      return {
        ...state,
        updateSurgeryNoteData: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_GET_SINGLE_SURGERY_NOTE: {
      let oldList = state?.singleSurgeryNote?.data;
      return {
        ...state,
        singleSurgeryNote: {
          loading: true,
          data: action?.payload?.offset > 0 ? oldList : {},
          error: {},
        },
      };
    }
    case SUCCESS_GET_SINGLE_SURGERY_NOTE: {
      let oldList = state?.singleSurgeryNote?.data;
      if (oldList?.list?.length > 0) {
        oldList.list = [...oldList?.list, ...action?.payload?.data?.list];
      } else {
        oldList = action?.payload?.data;
      }
      return {
        ...state,
        singleSurgeryNote: {
          loading: false,
          data: oldList,
          error: {},
        },
      };
    }
    case ERROR_GET_SINGLE_SURGERY_NOTE: {
      return {
        ...state,
        singleSurgeryNote: {
          loading: false,
          data: {},
          error: {},
        },
      };
    }
    case START_GET_PRINT_SURGERY_LIST: {
      return {
        ...state,
        printSurgeryList: {
          loading: true,
          data: [],
        },
      };
    }
    case SUCCESS_GET_PRINT_SURGERY_LIST: {
      return {
        ...state,
        printSurgeryList: {
          loading: false,
          data: action?.payload?.data?.list,
        },
      };
    }
    case ERROR_GET_PRINT_SURGERY_LIST: {
      return {
        ...state,
        printSurgeryList: {
          loading: false,
          data: [],
        },
      };
    }
    case START_DELETE_SURGERY_NOTE: {
      return {
        ...state,
        deleteSurgeryNoteData: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_DELETE_SURGERY_NOTE: {
      let oldList = state?.surgeryNoteList?.data;
      oldList.list = oldList?.list?.filter((item) => item?.id != action?.id);
      oldList.filterd_record = oldList?.filterd_record - 1;
      return {
        ...state,
        deleteSurgeryNoteData: {
          loading: false,
          data: action.payload,
          error: {},
        },
      };
    }
    case ERROR_DELETE_SURGERY_NOTE: {
      return {
        ...state,
        deleteSurgeryNoteData: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    default: {
      return state || initialState;
    }
  }
};
